import { render, staticRenderFns } from "./ConversationMessage.vue?vue&type=template&id=472de834&scoped=true&"
import script from "./ConversationMessage.vue?vue&type=script&lang=js&"
export * from "./ConversationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMessage.vue?vue&type=style&index=0&id=472de834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472de834",
  null
  
)

export default component.exports